// src/components/store/sections/hero-banner/HeroV45OrigamiribbonIndigoPulse.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV45OrigamiribbonIndigoPulse(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={45}
      archKey="origami_ribbon"
      archLabel="Origami Folded Hero"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      {...props}
    />
  );
}
